export default __webpack_public_path__ + "static/media/chart.e769d9b3.svg";